(function (pixel, $, undefined) {
    // This encompasses all the different Pixel event actions.
    // Base Pixel is included at RolandCloud.Web.Views.Shared.Includes.Footer._JavaScript.cshtml
    // Where does "fbq" get defined? It gets defined during this Base Pixel call.

    pixel.cancelSubscription = function (content_category_name) {
        // Referenced when the user clicks on a "Cancel Sub" button.
        // "CancelSubscription" is a custom track event name.

        try {
            fbq("trackCustom", "CancelSubcription", {
                content_name: "Cancel Subscription button",
                content_category: content_category_name
            });
            //console.log("Pixel: CancelSubscription: %s", content_category_name);
        }
        catch (e) {
            //console.log(e);
        }

    }

    pixel.leadSignup = function (content_category_name, placement) {
        // Referenced when a user signs up and is in trial mode.
        // "Lead" is a default Pixel track event name.

        try {
            var full_placement = "Sign Up button, " + placement;
            fbq("track", "Lead", {
                content_name: full_placement,
                content_category: content_category_name
            });
            //console.log("Pixel: Lead: %s", full_placement);
        }
        catch (e) {
            //console.log(e);
        }

    }
    
    pixel.leadComplete = function (content_category_name) {
        // Referenced when a user signs up and is in trial mode.
        // "LeadComplete" is a custom Pixel track event name.

        try {
            fbq("trackCustom", "LeadComplete", {
                content_name: "Sign Me Up button",
                content_category: content_category_name
            });
            //console.log("Pixel: LeadComplete: %s", content_category_name);
        }
        catch (e) {
            //console.log(e);
        }

    }

    pixel.initiateCheckout = function (content_category_name) {
        // Referenced when subscribe is clicked and Xsolla cart is initiated.
        // "InitiateCheckout" is a default Pixel event name.

        try {
            fbq("track", "InitiateCheckout", {
                content_name: "Subcribe button",
                content_category: content_category_name
            });
            //console.log("Pixel: InitiateCheckout: %s", content_category_name);
        }
        catch (e) {
            //console.log(e);
        }

    }

    pixel.AddToCart = function () {
        // Referenced when a user adds items to cart.
        // "AddToCart" is a default Pixel event name.

        try {
            fbq("track", "AddToCart", {
                content_name: "Subscription plan added"
            });
            //console.log("Pixel: InitiateCheckout: %s", content_category_name);
        }
        catch (e) {
            //console.log(e);
        }

    }

    pixel.addPaymentInfo = function () {
        // Referenced when a user fills out credit card info in Xsolla.
        // "AddPaymentInfo" is a default Pixel event name.

        try {
            fbq("track", "AddPaymentInfo", {
                content_category: "Xsolla Cart"
            });
            //console.log("Pixel: InitiateCheckout: %s", content_category_name);
        }
        catch (e) {
            //console.log(e);
        }

    }

    pixel.Purchase = function (purchase_value, purchase_currency) {
        // Referenced when a user completes a purchase.
        // "Purchase" is a default Pixel event name.

        try {
            fbq("track", "Purchase", {
                value: purchase_value,
                currency: purchase_currency,
                content_name: "Subscription purchased"
            });
            //console.log("Pixel: InitiateCheckout: %s", content_category_name);
        }
        catch (e) {
            //console.log(e);
        }

    }


})(window.pixel = window.pixel || {}, jQuery);




// WEBPACK FOOTER //
// ./Content/js/app/pixel.js